import React from 'react'
import VoidChecksProvider from './index.provider'
import VoidChecksContent from './index.content'

const VoidChecksScreen: React.FC = () => {
  return (
    <VoidChecksProvider>
      <VoidChecksContent />
    </VoidChecksProvider>
  )
}

export default VoidChecksScreen
